import { PrintDoc } from '../print/PrintDoc';
import { fmt } from '../shared/badges';

export const ConditionnementDoc = ({ row, projet = false, onClose }) => (
  <PrintDoc type={projet ? 'Ordre de mise en bouteille — préparation' : 'Bon de conditionnement réalisé'}
    format="a4" compact numero={projet ? 'PRÉVISION — non exécutée' : row.id} date={row.date}
    lignes={[
      ['Cuve source', row.cuveNom], ['Dénomination', row.denomination],
      ...row.lignes.map((l, i) => [`${i + 1}. ${l.nom}`, `${fmt(l.unites)} unités × ${fmt(l.litres, 3)} L = ${fmt(l.unites * l.litres, 3)} L`]),
      ['Total bouteilles / bidons', `${fmt(row.unites)} unités`],
      ['Volume total', `${fmt(row.litres, 3)} L`], ['Huile correspondante', `${fmt(row.kg, 3)} kg`],
    ]}
    mentions={projet ? 'Consigne de préparation uniquement : aucun stock modifié. Après exécution, vérifier les quantités réelles puis valider le conditionnement dans l’ERP.' : 'Conditionnement enregistré : huile et emballages consommés, produits finis créés. Réimprimer cette fiche ne modifie aucun stock.'}
    signatures={['Visa — responsable', 'Visa — opérateur conditionnement']} onClose={onClose} />
);
